/**
 * defa.views.RecipientsContainerView
 * A Container for all the recipient related views.
 * @version 1.0.0
 */

import RecipientGroupUpdateForm         from './view-recipient-group-update-form';
import { RecipientGroupCollectionView } from './view-recipient-groups-collection-view';
import RecipientGroupCreateForm         from './view-recipient-group-create-form';
import RecipientGroupDeleteForm         from './view-recipientGroup-delete-form';
import RecipientGroup                   from './model-recipientGroup';
import ActiveContainer                  from '../../poppet/active-container';
import template                         from '../notifications/template-recipients-container.jst.html';

const channelNav = Bb.Radio.channel( 'nav' );
const selectors = {
	addRecipientButton : '[data-click=recipient-create]',
	container          : '[data-region=container]',
	cancel             : '[data-click=recipients-cancel]'
};

export const RecipientsContainerView = ActiveContainer.extend( {
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	
	template,
	regions   : {
		container: selectors.container
	},
	
	ui : {
		add : selectors.addRecipientButton,
		cancel : selectors.cancel,
	},
	
	events: {
		'click @ui.add' : 'onClickAdd'
	},
	
	childViewEvents: {
		'delete:recipient:group' : 'deleteRecipientGroup'
	},
	
	
	navHandler: 'internal',
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	/**
	 * Triggers when a user clicks the @ui.add button.
	 * @void
	 */
	onClickAdd: function(event){
		event.preventDefault();
		channelNav.trigger( 'unit:recipients:new', [ this.options.recipientGroupHolderId ] );
	},
	
	/**
	 * Triggers when the child view triggers an "open" event.
	 * This happens when the user clicks on an existing recipient group.
	 * @void
	 */
	onChildviewOpen( childView ) {
		channelNav.trigger( 'unit:recipient:edit', [ childView.model.get( 'unit' ), childView.model.get('id'), ] );
	},
	
	/**
	 * Triggers when the child view triggers a "delete:recipient:group" event.
	 * This happens when the user clicks the delete button on a existing recipient group.
	 * @void
	 */
	deleteRecipientGroup: function(collectionView, model){
		channelNav.trigger('unit:recipient:delete', [ this.options.recipientGroupHolderId, model.get('id') ],);
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Attaches a designated view into the container region.
	 * @void
	 */
	attachView() {
		switch ( this.options.view ) {
			case 'unit:recipients':
				this.showRecipientGroups();
				break;
			
			case 'unit:recipient':
				this._showEditRecipientGroup();
				break;
			
			case 'unit:recipient:new':{
				let newRecipientGroup = new RecipientGroup({unit : this.options.recipientGroupHolderId});
				this._showCreateRecipientGroup(newRecipientGroup);
				break;}
				
			case 'unit:recipient:delete': {
				this._showDeleteRecipientGroup();
				break;
			}
		}
	},
	
	/**
	 * Displays a collectionView of all recipientGroups.
	 * @void
	 */
	showRecipientGroups() {
		this.showElement('cancel')
		this.showElement('add');
		let recipiengroups = this.options.recipientGroupHolder.get('recipientGroups')
		if(!recipiengroups.length){
			channelNav.trigger( 'unit:recipients:new', [ this.options.recipientGroupHolderId ] );
		}else{
			let notificationRecipientsView = new RecipientGroupCollectionView({
				collection: this.options.recipientGroupHolder.get('recipientGroups')
			});
			this.showChildView( 'container', notificationRecipientsView );
		}
	},
	
	/**
	 * Displays a delete view for a specific recipientGroup .
	 * @void
	 */
	_showDeleteRecipientGroup: function(){
		this.hideElement('add');
		this.hideElement('cancel');
		
		let recipientDeleteView = new RecipientGroupDeleteForm( {
			model: this.options.recipientGroupHolder.get( 'recipientGroups' ).get( this.options.recipientGroupId )
		} );
		this.showChildView( 'container', recipientDeleteView );
	},
	
	/**
	 * Displays a edit/update view for a specific recipientGroup .
	 * @void
	 */
	_showEditRecipientGroup() {
		this.hideElement('add');
		this.hideElement('cancel');
		let editRecipientView = new RecipientGroupUpdateForm( {
			model: this.options.recipientGroupHolder.get( 'recipientGroups' ).get( this.options.recipientGroupId )
		} );
		this.showChildView( 'container', editRecipientView );
	},
	
	/**
	 * Displays a create view for a new recipientGroup .
	 * @void
	 */
	_showCreateRecipientGroup: function(model){
		this.hideElement('add');
		this.hideElement('cancel');
		
		//TODO! Do this in the controller instead
		let recipiengroups = this.options.recipientGroupHolder.get('recipientGroups')
		if(!recipiengroups.length){
			this.options.closeLink.event = 'unit:control:notifications'
		}
		
		
		this.listenToOnce(model, 'sync', function(){
			channelNav.trigger( 'unit:recipient:edit', [ model.get('unit'), model.get('id'), ] );
		});
		
		let createRecipientGroupForm = new RecipientGroupCreateForm({
			model:model
		});
		this.showChildView( 'container', createRecipientGroupForm );
	},
} );
export default RecipientsContainerView;
